import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=7826089c&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=7826089c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826089c",
  null
  
)

export default component.exports